// DeleteConfirmationModal.js
import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./DeleteConfirmationModal.css";

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  contractName, 
  isDeleting 
}) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  return (
    <div className="delete-project-overlay">
      <div className="delete-project-content">
        <div className="delete-project-header">
          <h3>Move to Archive</h3>
          <button 
            className="delete-project-close" 
            onClick={onClose} 
            disabled={isDeleting}
          >
            ✕
          </button>
        </div>

        <div className="delete-project-body">
          <p className="delete-project-message">
            Enter reason for moving <b>"{contractName}"</b> into archive:
          </p>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason..."
            rows={4}
            style={{ width: "90%", padding: "8px", borderRadius: "4px" }}
          />
        </div>

        <div className="delete-project-footer">
          <button 
            className="delete-project-cancel" 
            onClick={onClose} 
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button 
            className="delete-project-delete" 
            onClick={() => onConfirm(reason)} 
            disabled={isDeleting || !reason.trim()}
          >
            {isDeleting ? (
              <>
                <CircularProgress size={18} sx={{ color: "#fff" }}/>
                &nbsp;Moving...
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
